module.exports = __webpack_public_path__ + "static/media/support-Suzette_Whyte.8e7c66bd.jpg";